import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconGrabberComponent } from "./med-icon-grabber.component";

@NgModule({
  declarations: [
    MedIconGrabberComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconGrabberComponent,
  ],
})
export class MedIconGrabberModule { }
